const COUNTRY_CODE = '62'

export const prependCountryCode = (phone: string) => {
  // handle "null", "" or "undefined"
  const phoneNumericOnly = phone?.replace(/[^\d]+/g, '') ?? ''
  if (phoneNumericOnly.length === 0) return phone

  // starts with '0'
  if (phoneNumericOnly?.[0] === '0') {
    return `${COUNTRY_CODE}${phoneNumericOnly.slice(
      1,
      phoneNumericOnly.length
    )}`
  }

  // starts with '8'
  if (phoneNumericOnly?.[0] === '8') {
    return `${COUNTRY_CODE}${phoneNumericOnly}`
  }

  return phoneNumericOnly
}
